var _defs, _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDistrainment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 30.76,
    cy: 31.48,
    r: 1.59,
    transform: "rotate(-60 30.757 31.487)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M28.14 35.58a11.896 11.896 0 01-7.61 2.75c-6.58 0-11.92-5.34-11.92-11.92s5.34-11.92 11.92-11.92 11.72 5.14 11.91 11.55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M17.75 9.7h5.57c.66 0 1.2.54 1.2 1.2v3.59h-7.98V10.9c0-.66.54-1.2 1.2-1.2zM20.5 9.54c.21-.93.23-3.37 2.28-4.63 1.89-1.16 4.07-.93 5.77.62"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M22.7 21.59c-5.97-1.73-5.97 4.53-2.2 4.44 3.69-.08 4.15 5.89-2.41 4.07M20.35 20.27v.54M20.35 30.94v.54M32.05 4.87l1.68-.55.61 1.65 1.47.96-.91 1.51.17 1.76-1.75.22-1.27 1.23-1.26-1.23-1.75-.22.17-1.76-.92-1.51 1.48-.96.61-1.65 1.67.55z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistrainment);
export default __webpack_public_path__ + "static/media/distrainment.c89ae67d380f489c692189ba578d0a73.svg";
export { ForwardRef as ReactComponent };